import { Copy, CopyCheck, X } from "lucide-react";

const ExitPopup = ({ closePopup, COUPON_CODE, handleCopyCode, copied }) => {
  return (
    <div
      onClick={closePopup}
      role="dialog"
      aria-modal="true"
      aria-labelledby="exit-popup-title"
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 animate-in fade-in duration-300"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-[400px] max-h-[550px] rounded-[30px] bg-white px-6 py-6 shadow-2xl animate-in fade-in slide-in-from-top-8 duration-500 "
      >
        <button
          onClick={closePopup}
          aria-label="Close popup"
          type="button"
          className="absolute right-4 bg-[#F9FAFB] rounded-full border border-[#E5E7EB] p-2 top-4"
        >
          <X size={16} strokeWidth={3} />
        </button>

        <div className="text-center">
          <div
            className="mb-4 flex items-center justify-center md:mb-5 md:text-[100px]"
            aria-hidden="true"
          >
            <img
              src="/assets/coupon-modal.svg"
              alt="Coupon Modal"
              width={80}
              height={80}
            />
          </div>

          <h2
            id="exit-popup-title"
            className="mb-3 w-[100%] mx-auto leading-[1.15]  text-xl font-extrabold text-[#170F49] md:text-[26px]"
          >
            Wait! Grab 5% Off Before You Go 🔥
          </h2>

          <p className="mb-7 text-[14px] leading-relaxed text-[#6B7280]">
            Get exclusive access to Imagive&apos;s AI-powered ad insights with
            your special coupon.
          </p>

          <div className="mb-6 rounded-2xl border border-[#E5E7EB] bg-[#F9FAFB] px-4 pb-4 pt-3">
            <p className="mb-2 text-base font-semibold text-[#374151]">
              Your coupon code:
            </p>
            <div className="flex items-center justify-between gap-2 rounded-xl bg-white p-1.5  border border-[#E5E7EB] shadow-sm">
              <span className="pl-4 text-xl font-bold text-[#111827] ">
                {COUPON_CODE}
              </span>
              <button
                type="button"
                onClick={handleCopyCode}
                aria-live="polite"
                className="btn-gradient font-semibold"
              >
                {copied ? (
                  <span className="flex items-center gap-1">
                    <CopyCheck size={16} strokeWidth={1.75} /> Copied!
                  </span>
                ) : (
                  <span className="flex items-center gap-1">
                    <Copy size={16} strokeWidth={1.75} /> Copy code
                  </span>
                )}
              </button>
            </div>
          </div>

          <a
            href="https://app.imagive.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary flex w-full items-center justify-center shadow-xl font-semibold"
          >
            Login &amp; Claim Offer
          </a>

          <p className="mt-2 text-sm text-[#6B7280]">
            Limited time offer- Don&apos;t miss out!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExitPopup;
